/**
 * ADMIN COMPANIES REACT QUERY HOOKS
 *
 * React Query hooks for managing companies in super admin dashboard
 */

import { useQuery } from '@tanstack/react-query';
import { AdminCompanyService, type CompanyFilters } from '@/services/adminCompanyService';

/**
 * Get all companies with license info and user counts
 */
export function useAdminCompaniesExtended(filters?: CompanyFilters) {
  return useQuery({
    queryKey: ['admin-companies-extended', filters],
    queryFn: () => AdminCompanyService.getAllCompanies(filters),
    staleTime: 2 * 60 * 1000,
  });
}

/**
 * Get company stats by status
 */
export function useAdminCompanyStats() {
  return useQuery({
    queryKey: ['admin-company-stats'],
    queryFn: () => AdminCompanyService.getCompanyStats(),
    staleTime: 5 * 60 * 1000,
  });
}

/**
 * Get single company with full details
 */
export function useAdminCompanyById(id: string | null) {
  return useQuery({
    queryKey: ['admin-company', id],
    queryFn: () => AdminCompanyService.getCompanyById(id!),
    enabled: !!id,
    staleTime: 1 * 60 * 1000,
  });
}
